<template>
	<div class="family_detail_index">
		<van-image width="100%" height="100%" :src="require('assets/img/family/family_top.png')"/>
		<div class="family_detail_index_header">
			<div class="family_detail_index_header_btn">
	        	<div class="mvbutton return" @click="goback">
	                返回上级
	            </div>
	            <div class="mvbutton continue " @click="signup">
	                我要报名
	            </div>
	        </div>
	        <div class="family_detail_index_header_notice">上传说明：上传视频在10MB以内（30~60秒）</div>
		</div>				
		<div class="family_detail_index_body">
			<div class="family_detail_index_body_btn">
				<div class="family_detail_index_body_btn_left">
					<div :class="['mvbutton', type==1?'selected':'default']" @click="goType(1)">
		                全部选手
		            </div>
				</div>
				<div class="family_detail_index_body_btn_right">
					<div :class="['mvbutton', type==2?'selected':'default']" @click="goType(2)">
		                家庭排行
		            </div>
				</div>
			</div>	
			<div class="family_detail_index_body_item">
				<template v-if="type==1">
					<VoteList v-if="familyList.length" :familyList="familyList" v-on:goVote="goVote"></VoteList>
            		<van-skeleton title  :row="2" :animate="false" v-else/>
				</template>
				<template v-else>
					<RankList v-if="rankList.front3.length" :rankList="rankList"></RankList>
					<van-skeleton title  :row="2" :animate="false" v-else/>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
    import './index.less'
    import { Image } from 'vant'; 
    import VoteList from '@/views/WholeFamily/VoteList'
    import RankList from '@/views/WholeFamily/RankList'
    export default {
        data(){
          return {
              familyList:[],
              rule:'',
              showrule:false,
              type:1,
              rankList:{}
          }
        },
        components:{
        	vanImage:Image,
        	VoteList,
        	RankList
        },
        methods:{
            getFamilyList(){
                this.$api.family.familyList().then((res)=>{
                    if(res.status*1===200){
                        console.log(res)
                        this.familyList  =   res.data.list
                        this.rule = res.data.rule
                    }

                })                
            },
            goType(type){
            	if(type==1){
            		this.type=1;
            		this.getFamilyList(); 
            	}else{
            		this.$api.family.voteRank().then((res)=>{
                    	if(res.status*1===200){
	                    	var front3=[];
	                		var rankList = res.data.list
                			let userInfo = res.data.myinfo
                			rankList.forEach((item, index) => {
			                    item.rank = index + 1;
			                    if (index < 3) {
			                        front3.push(Object.assign({}, item));
			                        delete rankList[index];
			                    }
			                })
			                this.type=2;
			                this.rankList['front3'] = front3
			                this.rankList['list'] = rankList
			                this.rankList['userInfo'] = userInfo//当前的排名
	                    }
	                })
            	}
            },
            goback(){
            	this.$router.go(-1);
            },
            signup(){
            	this.$router.push({name:'familysignup'})
            },
            goVote(val){
            	localStorage.setItem('vote', JSON.stringify(val));
                this.$router.push({name:'vote'})
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getFamilyList();            
            })
        }
    }
</script>